module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"goodsTypes":"Goods Types","selectGoodsTypes":"Select goods types","goodsTypesSelected":"All goods types | {count} goods type selected | {count} goods types selected"},"no":{"goodsTypes":"Godstyper","selectGoodsTypes":"Velg godstyper","goodsTypesSelected":"Alle godstyper | {count} godstype valgt | {count} godstyper valgt"}}')
  delete Component.options._Ctor
}
